import React from 'react';
import { Appeal } from '../../../types/product';
import { ArrayInputField } from '../ArrayInputField';

interface AppealSectionProps {
  value: Appeal;
  onChange: (value: Appeal) => void;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数（sections 共通の見た目）。
const SECTION = 'bg-white border border-[#e0e0e0] rounded-lg p-6 mb-6';
const SECTION_TITLE = 'm-0 mb-2 text-[18px] font-semibold text-[#333]';
const SECTION_DESCRIPTION = 'm-0 mb-6 text-[14px] text-[#666]';
const FIELD_GROUP = 'mb-5 last:mb-0';
const LABEL = 'block mb-2 text-[14px] font-semibold text-[#333]';
const INPUT =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const TEXTAREA =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] [font-family:inherit] resize-y transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const HELP_TEXT = 'm-0 mt-1.5 text-[12px] text-[#666]';

export const AppealSection: React.FC<AppealSectionProps> = ({
  value,
  onChange
}) => {
  const handleRecommendedTypesChange = (recommended_types: string[]) => {
    onChange({ ...value, recommended_types });
  };

  const handleChange = (field: keyof Appeal, fieldValue: string) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div className={SECTION}>
      <h3 className={SECTION_TITLE}>訴求情報</h3>
      <p className={SECTION_DESCRIPTION}>
        マーケティング訴求の方向性とメッセージを入力してください
      </p>

      <ArrayInputField
        label="推奨訴求タイプ"
        value={value.recommended_types || []}
        onChange={handleRecommendedTypesChange}
        placeholder="例: 価値訴求、ベネフィット訴求"
        maxItems={10}
        helpText="効果的な訴求アプローチのタイプ"
      />

      <div className={FIELD_GROUP}>
        <label className={LABEL}>訴求の方向性</label>
        <textarea
          className={TEXTAREA}
          value={value.direction || ''}
          onChange={(e) => handleChange('direction', e.target.value)}
          placeholder='例: 「手間ゼロ・安心・環境」の3軸で家庭の共感を引き出す'
          rows={3}
        />
        <p className={HELP_TEXT}>全体的なマーケティングメッセージの方向性</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>勝ちコピー例</label>
        <input
          className={INPUT}
          type="text"
          value={value.winning_copy || ''}
          onChange={(e) => handleChange('winning_copy', e.target.value)}
          placeholder='例: 手間ゼロで、家族の"いつも"を清潔に。'
          maxLength={500}
        />
        <p className={HELP_TEXT}>効果的なコピーライティングの参考例</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>訴求構造パターン</label>
        <input
          className={INPUT}
          type="text"
          value={value.structure_pattern || ''}
          onChange={(e) => handleChange('structure_pattern', e.target.value)}
          placeholder="例: フック→課題→解決→証拠→CTA"
          maxLength={500}
        />
        <p className={HELP_TEXT}>訴求メッセージの構成パターン</p>
      </div>
    </div>
  );
};
